import React from "react";
import { Box, Tab, Tabs as MUITabs, Tooltip } from "@mui/material";
import { Warning } from "@mui/icons-material";
import IyugaTooltip from "../../../IyugaTooltip";

const Tabs = ({
  selectedTab,
  setSelectedTab,
  tabList,
  orientation = "vertical",
  borderTop = false,
  tabErrors = {}, // Object containing error information for each tab
}) => {
  const tabStyle = (value) => ({
    color: selectedTab === value ? "#8126DB" : "#00000099",
    fontSize: "14px",
    lineHeight: "20px",
    marginBottom: "10px",
    borderRadius: "4px",
    textTransform: "capitalize",
    borderLeft:
      selectedTab === value && !borderTop ? "3px solid #8126DB" : "none",
    borderTop:
      selectedTab === value && borderTop ? "3px solid #8126DB" : "none",
    backgroundColor: selectedTab === value ? "#EFE9FE" : "#F6F7F9",
    fontWeight: "700",
    display: "flex",
    justifyContent: "space-evenly",
    flex: 1,
    minWidth: 0,
  });

  const handleTabChange = (e, newVal) => {
    setSelectedTab(newVal);
  };

  return (
    <Box
      sx={{
        bgcolor: "background.paper",
        display: "flex",
        padding: orientation === "vertical" && "0px 20px",
        width: "100%",
      }}
    >
      <MUITabs
        orientation={orientation}
        variant="fullWidth"
        value={selectedTab}
        onChange={handleTabChange}
        aria-label="Vertical tabs example"
        TabIndicatorProps={{ style: { display: "none" } }}
        sx={{
          width: "100%",
          "& .MuiTabs-flexContainer": {
            width: "100%",
            display: "flex",
            gap: orientation === "horizontal" ? "10px" : 0, // Add gap using flexbox
            justifyContent: "space-between",
          },
        }}
      >
        {tabList.map(({ label, value, icon: Icon }) => (
          <Tab
            key={value}
            label={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  justifyContent: "center", // Center content
                  gap: "6px", // Add gap between elements
                }}
              >
                {Icon && <Icon sx={{ fontSize: 16, width: 16, height: 16 }} />}
                <span>{label}</span>
                {tabErrors[value] && (
                  <IyugaTooltip
                    placement="top"
                    tooltip="Some fields are missing or invalid"
                  >
                    <Warning
                      sx={{
                        fontSize: 16,
                        width: 16,
                        height: 16,
                        color: "#f57c00",
                        ml: "2px",
                      }}
                    />
                  </IyugaTooltip>
                )}
              </Box>
            }
            value={value}
            style={tabStyle(value)}
          />
        ))}
      </MUITabs>
    </Box>
  );
};

export default Tabs;
